import Button from "../button/button";

function ModalAudios({ isOpen, onClose, children }) {
  const modalStyle = {
    display: isOpen ? "flex" : "none", // Controla la visibilidad del modal
  };

  return (
    <div
      style={modalStyle}
      className="fixed top-0 left-0 w-full min-h-screen bg-chatbg bg-opacity-50 backdrop-blur-2xl backdrop-saturate-200 z-sticky flex items-center justify-center"
    >
      <div className="w-[95%] max-h-[80vh] bg-DarkBlue-700/90 py-6 px-6 rounded-4 shadow-dark-xl flex flex-col overflow-hidden">
        <div className="relative flex-1 overflow-auto">
          {children}
        </div>
        <div className="mt-4 flex justify-center">
          <Button
            label={"Cerrar"}
            variant="primary"
            onClick={onClose}
          />
        </div>
      </div>
    </div>
  );
}

export default ModalAudios;
